import React from 'react';

import { Modal, Button, Col, Card, Row } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import Avatar from '../../common/Avatar';
import ItemCompact from '../../common/ItemCompact';

import moment from 'moment';
import _ from 'lodash';

class DetalleContraventor extends React.Component {
  state = { visible: false };

  render() {
    if (!this.props.contraventor || !this.props.contraventor.persona) {
      return null;
    }

    let { persona } = this.props.contraventor;
    return (
      <div>
        <Modal
          title={
            <h3>
              <Icons.FileSearchOutlined /> Detalle del Contraventor
            </h3>
          }
          visible={this.props.visible}
          onCancel={this.props.ocultarModal}
          width={800}
          footer={[
            <Button key="back" type="primary" onClick={this.props.ocultarModal}>
              Volver
            </Button>,
          ]}
        >
          <Col span={24}>
            <Card bordered={false} style={{ boxShadow: 'none' }}>
              <Row type={'flex'} justify={'start'} gutter={16}>
                <Col span={6}>
                  {_.includes(['DNI', 'D.N.I.'], persona.tipo_doc) ? (
                    <Avatar idPersona={persona._id} />
                  ) : (
                    <Avatar />
                  )}
                </Col>
                <Col span={18}>
                  <Row type={'flex'} justify={'start'} gutter={16}>
                    <ItemCompact
                      title={'Apellido y Nombre: '}
                      content={`${persona.apellido} ${persona.nombre}`}
                      fontSize={16}
                      span={12}
                    />
                  </Row>
                  <Row type={'flex'} justify={'start'} gutter={10}>
                    <ItemCompact
                      title={`${persona.tipo_doc}:`}
                      content={`${_.get(persona, 'num_doc', '')}`}
                      span={6}
                    />
                    <ItemCompact
                      title={'Fecha Nacimiento: '}
                      content={`${
                        persona.fecha_nacimiento
                          ? moment(persona.fecha_nacimiento).format(
                              'DD/MM/YYYY'
                            )
                          : 'Sin especificar'
                      }`}
                      span={6}
                    />
                    <ItemCompact
                      title={'Edad: '}
                      content={Math.floor(
                        moment(new Date()).diff(
                          moment(persona.fecha_nacimiento),
                          'years',
                          true
                        )
                      )}
                      span={6}
                    />
                    <ItemCompact
                      title={'Profesión: '}
                      content={`${_.get(persona, 'profesion', 'SIN DATOS')}`}
                      span={6}
                    />
                  </Row>

                  <Row type={'flex'} justify={'start'} gutter={10}>
                    <ItemCompact
                      title={`Ciudad:`}
                      content={`${_.get(persona, 'localidad.nombre', '')}`}
                      span={10}
                    />

                    <ItemCompact
                      title={'Direccion: '}
                      content={
                        persona.direccion_calle && persona.direccion_numero
                          ? persona.direccion_calle +
                            ' ' +
                            persona.direccion_numero
                          : 'SIN DATOS'
                      }
                      span={14}
                    />
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>
        </Modal>
      </div>
    );
  }
}

export default DetalleContraventor;
